exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#cd-login{display:inline-block}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/layout/header/header.component.scss"],"names":[],"mappings":"AAAA,UACC,oBAAqB,CACrB","file":"header.component.scss","sourcesContent":["#cd-login {\n\tdisplay: inline-block;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/layout/header/header.component.scss
// module id = /fDe
// module chunks = 2